import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class Coordinators extends CommonCRUD {}

export default Coordinators;
